import styled from 'styled-components';
import { FormTitle } from '@app/components/layouts/AuthLayout/AuthLayout.styles';

export const Title = styled(FormTitle)`
  margin-bottom: 1.875rem;
`;
